import React, { useEffect, useState } from "react";
import {
  Card,
  Grid,
  Typography,
  Avatar,
  Box,
  Button,
  Chip,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import EventIcon from "@mui/icons-material/Event";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import EmailIcon from "@mui/icons-material/Email";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useCandidateLayout } from "../../Components/Context/CandidateLayoutContext";

export default function CandidateSummary() {
  const { candidateData, candidateJobData } = useCandidateLayout();

  const Navigate = useNavigate();

  const [notifications, setNotifications] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const getNotification = async () => {
    try {
      const res = await axiosAPI.post(`/Notification/list`, {
        UserId:
          localStorage?.getItem("SWA_UserId") ||
          sessionStorage?.getItem("SWA_UserId"),
      });
      setNotifications(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleRead = async (item) => {
    try {
      const res = await axiosAPI.post(`Notification/updateStatus`, {
        isRead: 1,
        NotificationId: item?.NM_Id,
      });
      if (res?.data?.success) {
        setRefresh(!refresh);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getNotification();
  }, [refresh]);

  return (
    <Box sx={{ p: 4, mx: "auto", }}>
      <CommonButton
        background="#006CB8"
        textColor="white"
        onClick={() => Navigate(`/`)}
        sx={{
          minWidth: "100px",
          color: "white",
          borderRadius: "20px",
          height: "30px",
          textTransform: "capitalize",
        }}
      >
        Back
      </CommonButton>

      <Typography
        sx={{
          fontSize: { xs: "16px", sm: "18px", lg: "22px" },
            fontFamily: "Geist, sans-serif",
          fontWeight: 700,
          margin:'10px auto',
        }}
      >
        Job Summary
      </Typography>

      <Box pl={2} sx={{ border: "1px solid lightgrey", borderRadius:2, p:2}}>
        {candidateJobData?.map((item, index) => (
          <Box
            key={index}
            sx={{
              position: "relative",
              top: "5px",
              minHeight: { sm: "", md: "70px" },
            }}
          >
            {/* Bullet marker */}
            <Box
              sx={{
                position: "absolute",
                left: 0,
                top: "10px",
                width: 12,
                height: 12,
                bgcolor: "#006CB8",
                borderRadius: "50%",
                zIndex: 1,
              }}
            />

            {/* Content */}
            <Grid
              container
              spacing={1}
              alignItems="flex-start"
              sx={{
                position: "relative",
                bottom: "5px",
                pl: "20px",
              }}
            >
              {/* Title + JobId */}
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography
                  sx={{
                    textAlign: "left",
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "18px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  {item?.JD_Title}
                </Typography>
                <Typography
                  sx={{
                    textAlign: "left",
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "400",
                  }}
                >
                  {item?.JD_JobId}
                </Typography>
              </Grid>

              {/* Date + Status */}
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                textAlign="left"
                sx={{ pr: { sm: 2 } }}
              >
                <Typography
                  sx={{
                    fontFamily: "Geist, sans-serif",
                    letterSpacing: `0.5px`,
                    fontSize: "16px",
                    color: "#333",
                    fontWeight: "600",
                  }}
                >
                  {item?.JA_AppliedDate}
                </Typography>
                <Chip
                  label={item?.JASL_Name}
                  sx={{
                    minWidth: "100px",
                    color: `white`,
                    backgroundColor: `#006CB8`,
                    mt: 0.5,
                  }}
                  size="small"
                />
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
